import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class AvailableDividendRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Év</TableCell>
                            <TableCell>Mikortól</TableCell>
                            <TableCell>Meddig</TableCell>
                            <TableCell>Összeg</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.year}</TableCell>
                            <TableCell>{this.props.row.availableFrom}</TableCell>
                            <TableCell>{this.props.row.availableUntil}</TableCell>
                            <TableCell>{this.props.row.amount}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default AvailableDividendRow;